'use strict';

function dropdownInit() {
    var $dd = $('.custom-dd');
    $dd.each(function (i, ele) { // check if page has one & more custom dropdown
        var $ddContainer = $(ele).find('.custom-dd-list-container'),
            $selectedOption = $ddContainer.find('.selected'),
            $selectedItem = $(ele).find('.custom-dd-list-selected-content');
        // to get selected option data
        $selectedItem.html($selectedOption.html());
        if ($selectedOption.hasClass('unselectable')) {
            $selectedItem.addClass('unselectable');
        } else {
            $selectedItem.removeClass('unselectable');
        }
        // init scrollbar
        $ddContainer.scrollBox();
    });
}
function dropdownClose() {
    var $dd = $('.custom-dd');
    $dd.removeClass('opened');
    // to re-init scrollbox
    $('.custom-dd .custom-dd-list-container').trigger('resize.scrollBox');

    // Avoid overlap on Bundle product
    if ($('.product-set-item-parent').length) {
        var productSetItemParent = $('.product-set-item-parent');
        if ($(productSetItemParent).hasClass('index-parent')) {
            $(productSetItemParent).removeClass('index-parent');
        }
    }
    if($(".cart-mini-recommendation-container").length) {
        $(".cart-mini-recommendations .slick-prev").show();
    }
}
function dropdownSelectedItemClick() {
    $(document).off('click','.custom-dd:not(.custom-dd-disabled) .custom-dd-list-item-selected').on('click', '.custom-dd:not(.custom-dd-disabled) .custom-dd-list-item-selected', function (e) {
        e.stopPropagation();
        var $ddCustom = $($(this).parents('.custom-dd')[0]),
            $ddContainer = $ddCustom.find('.custom-dd-list-container')[0],
            $ddSelected = $ddCustom.find('.custom-dd-list-item-selected')[0].offsetHeight,
            isCartDropdown = $ddCustom.closest('.cart-body').length > 0;

        dropdownClose();
        if ($('.product-set-item-parent').length) { // Avoid overlap on Bundle product
            var productSetItemParent = $($(this).parents('.product-set-item-parent')[0]);
            productSetItemParent.addClass('index-parent');
        }

        $ddCustom.removeClass('opened');
        // to make dropdown visible
        $ddCustom.addClass('opened');

        // to re-init scrollbox
        $('.custom-dd .custom-dd-list-container').trigger('resize.scrollBox');

        // to change dropdown position based on available viewport height
        !$ddCustom.parents('.minicart-recommendations') && $($ddContainer).position({
            'my': 'left top-' + $ddSelected,   //  Horizontal then vertical, default to center
            'at': 'left bottom',  //  Horizontal then vertical, default to center
            'of': $ddCustom.find('.custom-dd-list-item-selected')[0], //  Element to position against		
            'collision': 'flip flip' //  flip the element top/bottom
        });
        if (isCartDropdown) {
            $($ddContainer).position({
                'my': 'left bottom',
                'at': 'left top',
                'of': $ddCustom.find('.custom-dd-list-item-selected')[0],
                'collision': 'none'
            });
        }
        if($(".cart-mini-recommendation-container").length) {
            $(".cart-mini-recommendations .slick-prev").hide();
        }
    });
}
function dropdownListItemClick() {
    $('.custom-dd:not(.custom-dd-disabled)').on('click', '.custom-dd-list-item', function() {
        var $dd = $(this).closest('.custom-dd');
        var $selectedItem = $dd.find('.custom-dd-list-selected-content');

        if($(this).hasClass('unselectable')) {
            $selectedItem.addClass('unselectable');
        } else {
            $selectedItem.removeClass('unselectable');
        }
        dropdownClose();
    });
}
function dropdownCloseOnDocumentClick() {
    $(document).on('click', function(event){
        var $dd = $('.custom-dd:not(.custom-dd-disabled)');
        var $ddContainer = $dd.find('.custom-dd-list-container');
        if($ddContainer !== event.target && !$ddContainer.has(event.target).length && $dd.hasClass('opened')){
            dropdownClose();
        }     
    });
}


var customDropdown = {	
    init: function () {
        $('.quick-shop-panel .custom-dd, .cart_page .custom-dd').removeClass('custom-dd-disabled');
        dropdownInit();
        dropdownSelectedItemClick();
        dropdownListItemClick();
        dropdownCloseOnDocumentClick();
    }
};

export default customDropdown;
